(() => {
  const loaded = new Set();
  const load = (url) => {
    if (!url || loaded.has(url)) return;
    loaded.add(url);
    const link = document.createElement('link');
    link.rel = 'stylesheet'; link.href = url; document.head.append(link);
  };
  const observe = (marker) => {
    if (marker.dataset.sggObserved) return;
    marker.dataset.sggObserved = 'true';
    const targets = marker.dataset.sggCssTarget ? document.querySelectorAll(marker.dataset.sggCssTarget) : [marker.closest('.shopify-section') || marker.parentElement];
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) { load(marker.dataset.sggDeferredCss); return; }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { load(marker.dataset.sggDeferredCss); observer.disconnect(); }
    }, { rootMargin: '0px' });
    targets.forEach(target => observer.observe(target));
  };
  const scan = () => document.querySelectorAll('[data-sgg-deferred-css]').forEach(observe);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
